import React from 'react';
import { useAtom } from 'jotai';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { chatOverlayOpenAtom, chatOverlayReturnAtom, createOverlayOpenAtom, modalOpenAtom, uiDesignerOpenAtom, activePageAtom, } from '@/stores/atoms/uiAtoms';
import { wsManager } from '@/utils/wsManager';
const BackButtonProvider = () => {
    const [chatOpen, setChatOpen] = useAtom(chatOverlayOpenAtom);
    const [chatReturn] = useAtom(chatOverlayReturnAtom);
    const [createOpen, setCreateOpen] = useAtom(createOverlayOpenAtom);
    const [uiOpen, setUiOpen] = useAtom(uiDesignerOpenAtom);
    const [modalOpen, setModalOpen] = useAtom(modalOpenAtom);
    const [, setActivePage] = useAtom(activePageAtom);
    const handleBack = React.useCallback(async () => {
        // Priority: UI Designer > Create Overlay > Chat Overlay > Modal > Page back to home
        if (uiOpen) {
            setUiOpen(false);
            return true;
        }
        if (createOpen) {
            setCreateOpen(false);
            return true;
        }
        if (chatOpen) {
            try {
                wsManager.close();
            }
            catch { }
            setChatOpen(false);
            // Transition matches ChatOverlay goBack timing
            setTimeout(() => setActivePage(chatReturn), 260);
            return true;
        }
        if (modalOpen) {
            setModalOpen(false);
            return true;
        }
        // At root page: exit app on Android
        try {
            if (Capacitor.getPlatform?.() === 'android') {
                await App.exitApp();
                return true;
            }
        }
        catch { }
        return false;
    }, [uiOpen, createOpen, chatOpen, modalOpen, chatReturn, setActivePage, setUiOpen, setCreateOpen, setChatOpen, setModalOpen]);
    React.useEffect(() => {
        let sub;
        try {
            if (Capacitor.getPlatform?.() === 'android') {
                sub = App.addListener('backButton', (e) => {
                    // prevent default browser history behavior
                    handleBack();
                });
            }
        }
        catch { }
        // Optional: support ESC on desktop/web
        const onKey = (ev) => {
            if (ev.key === 'Escape') {
                handleBack();
            }
        };
        window.addEventListener('keydown', onKey);
        return () => {
            try {
                sub?.remove?.();
            }
            catch { }
            window.removeEventListener('keydown', onKey);
        };
    }, [handleBack]);
    return null;
};
export default BackButtonProvider;
